import React, {useEffect } from 'react'; 
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const SmartClassrooms = () => {
    useEffect(() => {
        document.title = 'Smart Classrooms -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                 <li>Smart Classrooms</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Smart Classrooms </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                    <p>E-learning is accorded top priority. This helps students schooling with us to be better equipped to meet the challenges of modern day living. Smart Boards have been installed in classes so that teachers can supplement the classroom teaching with audio visual display systems which help children learn much faster. Such learning through audio visual aids is better absorbed, since abstract concepts are given particular shapes & colours.</p>
                </div>
                <div className="col-lg-12">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/SmartClassrooms.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/SmartClassrooms.jpg" className="mx-auto d-block schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div> 
            </div>
            </div>
        </div>
     </>
  )
}

export default SmartClassrooms